export const sentryMetricAlertViewSample = {
  'action': 'resolved',
  'actor': {
    'id': 'sentry',
    'name': 'Sentry',
    'type': 'application'
  },
  'data': {
    'description_text': '1000 events in the last 10 minutes\\nFilter: level:error',
    'description_title': 'Resolved: Too many errors',
    'metric_alert': {
      'alert_rule': {
        'aggregate': 'count()',
        'created_by': null,
        'dataset': 'events',
        'date_created': '2020-09-13T12:26:40.000000Z',
        'date_modified': '2020-09-13T12:26:40.000000Z',
        'environment': null,
        'id': '7',
        'include_all_projects': false,
        'name': 'Too many errors',
        'organization_id': '5',
        'projects': ['bar'],
        'query': 'level:error',
        'resolution': 1,
        'resolve_threshold': null,
        'status': 0,
        'threshold_period': 1,
        'threshold_type': 0,
        'time_window': 10,
        'triggers': []
      },
      'date_closed': null,
      'date_created': '2020-09-13T12:26:40.000000Z',
      'date_detected': '2020-09-13T12:26:40.000000Z',
      'date_started': '2020-09-13T12:26:40.000000Z',
      'id': '4',
      'identifier': '1',
      'organization_id': '5',
      'projects': ['bar'],
      'status': 2,
      'status_method': 3,
      'title': 'Sacred Marmot',
      'type': 2
    },
    'web_url': 'https://sentry.io/organizations/baz/alerts/1/'
  },
  'installation': {
    'uuid': 'a8e5d37a-696c-4c54-adb5-b3f28d64c7de'
  }
};

  export const sentryMetricAlertSample = {
    'action': 'resolved',
    'data.description_text': '1000 events in the last 10 minutes\\nFilter: level:error',
    'data::metric_alert.id': '4',
    'data::metric_alert.date_created': '2020-09-13T12:26:40.000000Z',
    'data::metric_alert.title': 'Sacred Marmot',
    'data::metric_alert::alert_rule.threshold_period': 1,
    'data::metric_alert.organization_id': '5',
  };
  


// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/sentry_metric_alert.ts